<template>
    <div class="frame">
        <NavBar v-if="showMenu" class="nav"/>
        <RouterView class="main"/>
        <widget-container-modal/>
    </div>
</template>

<script setup>
    import { provide, computed } from 'vue';
    import { RouterView, useRoute, useRouter } from 'vue-router';
    import { container as WidgetContainerModal, config as modalConfig } from 'jenesius-vue-modal';
    import NavBar from '../components/NavBar.vue';
    import { Api } from '../lib/Api';
    import 'ag-grid-community/styles/ag-grid.css';
    import 'ag-grid-community/styles/ag-theme-quartz.css';
    import '../../overrides.css';

    const route = useRoute();
    const router = useRouter();
    const api = new Api(router);
    window.cleanupApi = api;
    provide('api', api);
    modalConfig({ backgroundClose: false }); // do not close modal if user clicks outside of modal window

    const showMenu = computed(() => route.name !== 'Login');
</script>

<style scoped>
    .frame {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .main {
        padding: 20px;
        flex: 1;
    }
</style>
